import moment from "moment";
import { DATE_FORMAT, Model } from "./Model";
import axios from "axios";
import { apiPost } from "@/session";
const TIME_FORMAT = "H:mm";
const DATETIME_FORMAT = DATE_FORMAT + TIME_FORMAT;
export default class CalendarEvent extends Model {
    static fromTyped(id, name, creator, created, modifier, modified, start, finish, detail) {
        return new CalendarEvent(id, name, creator, created.format(), modifier, modified.format(), start.format(DATE_FORMAT), start.format(TIME_FORMAT), finish.format(TIME_FORMAT), detail);
    }
    static fromJson(data) {
        return new CalendarEvent(data.id, data.name, data.creator, data.created, data.modifier, data.modified, data.startDate, data.startTime, data.finishTime, data.detail);
    }
    static get blank() {
        return CalendarEvent.fromTyped(0, "", "", moment(), "", moment(), moment(), moment().add(1, "hour"), "");
    }
    constructor(id, name, creator, created, modifier, modified, startDate, startTime, finishTime, detail) {
        super(created, modified);
        this.data.id = id;
        this.data.name = name;
        this.data.creator = creator;
        this.data.modifier = modifier;
        this.data.startDate = "";
        this.data.startTime = "";
        this.data.finishTime = "";
        this.data.detail = detail;
        this.start = moment(startDate + startTime, DATETIME_FORMAT);
        this.finish = moment(startDate + finishTime, DATETIME_FORMAT);
        this.modifiedSince = false;
    }
    update() {
        return axios.patch(process.env.VUE_APP_ROOT_API + "/events/" + this.id, {
            name: this.name,
            start_date: this.start.format(DATE_FORMAT),
            start_time: this.start.format(TIME_FORMAT),
            finish_time: this.finish.format(TIME_FORMAT),
            detail: this.detail,
        }, { withCredentials: true }).then((stat) => {
            return stat.status === 200;
        }).catch(() => {
            return false;
        });
    }
    insert() {
        return apiPost("/events/", {
            name: this.name,
            startDate: this.start.format(DATE_FORMAT),
            startTime: this.start.format(TIME_FORMAT),
            finishTime: this.finish.format(TIME_FORMAT),
            detail: this.detail,
        }).then((stat) => {
            if (stat.status !== 201) {
                throw new Error(JSON.stringify(stat.data));
            }
            return stat.data.insertId;
        });
    }
    get id() {
        return this.data.id;
    }
    get name() {
        return this.data.name;
    }
    set name(val) {
        if (this.data.name !== val) {
            this.modify();
            this.data.name = val;
        }
    }
    get creator() {
        return this.data.creator;
    }
    set creator(val) {
        if (this.data.creator !== val) {
            this.modify();
            this.data.creator = val;
        }
    }
    get modifier() {
        return this.data.modifier;
    }
    set modifier(val) {
        if (this.data.modifier !== val) {
            this.modify();
            this.data.modifier = val;
        }
    }
    get start() {
        return this.cache.start.clone();
    }
    set start(val) {
        const ds = val.format(DATE_FORMAT);
        const ts = val.format(TIME_FORMAT);
        if (this.data.startDate !== ds || this.data.startTime !== ts) {
            this.modify();
            this.data.startDate = ds;
            this.data.startTime = ts;
            this.cache.start = moment(ds + ts, DATETIME_FORMAT);
            this.cache.finish = moment(ds + this.data.finishTime, DATETIME_FORMAT);
        }
    }
    get finish() {
        return this.cache.finish;
    }
    set finish(val) {
        const ts = val.format(TIME_FORMAT);
        if (this.data.finishTime !== ts) {
            this.modify();
            this.data.finishTime = ts;
            this.cache.finish = moment(this.data.startDate + this.data.finishTime, DATETIME_FORMAT);
        }
    }
    get detail() {
        return this.data.detail;
    }
    set detail(val) {
        if (this.data.detail !== val) {
            this.modify();
            this.data.detail = val;
        }
    }
}
//# sourceMappingURL=CalendarEvent.js.map